import { useCallback } from 'react';
const useAppRating = () => useCallback(async () => false, []);
export default useAppRating;
